<template>
  <el-form-item>
    <template #label>
      <span :style="{display: 'flex','align-items': 'center',color:'#344262','font-weight':context.formStyleSetting.PC.title}">{{ element.label }}
        <form-element-tooltip :element="element"></form-element-tooltip>
      </span>
    </template>
   <el-input placeholder="请选择" suffix-icon="CircleCheckFilled" readonly></el-input>
  </el-form-item>
</template>

<script>

import FormElementTooltip from "@/components/common/formElementTooltip.vue";

export default {
  components: {FormElementTooltip},
  props: {
    context: {
      type: Object,
      default: () => {
      }
    },
    element: {
      type: Object,
      default: () => {
      }
    },
    parent: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      data: this.element
    }
  }
}

</script>

<style scoped lang="scss">

.el-radio{
  font-weight: normal;
}

</style>